<template>
  <div class="template-default">
    <div>
      <b-alert
        :show="alertExpire"
        fade
        :variant="variant"
        style="margin-bottom: 0 !important;"
      >
        <div class="d-flex justify-content-between align-items-center">
          <span>{{ textAlert }}</span>
          <div>
            <button class="btn ml-4" @click="alertExpire = false">
              <i class="icon-x"></i>
            </button>
          </div>
        </div>
      </b-alert>
    </div>

    <div v-if="$user.user" class="container-fluid">
      <slot />
    </div>
    <div v-else class="d-flex justify-content-center p-5">
      <b-spinner />
    </div>

    <b-modal v-model="formDialog" size="lg" hide-header hide-footer centered>
      <task-list @close="formDialog = false" />
    </b-modal>
  </div>
</template>

<script>
import TaskList from "../components/home/TaskList";

export default {
  components: { TaskList },
  data() {
    return {
      formDialog: false,
      alertExpire: false,
      textAlert: "",
      days: 0,
      variant: "info"
    };
  },
  beforeUpdate() {
    this.handleTrialCheck();
  },
  beforeMount() {
    this.handleTrialCheck();
  },
  methods: {
    handleTrialCheck() {
      setTimeout(() => {
        const userStatus = this.$user.agency.status;
        if (this.$user.agency.trial_date !== "") {
          this.days = parseInt(this.$user.agency.trial_date) ?? 0;
          if (this.days >= 1 && this.days <= 10) {
            this.alertExpire = false;
            // const now = new Date();
            // const past = new Date(this.$user.agency.trial_date);
            // const diff = Math.abs(now.getTime() - past.getTime());
            // this.days = Math.ceil(diff / (1000 * 60 * 60 * 24));
            if (this.days <= 3) {
              this.alertExpire = true;
              this.variant = "danger";
            } else if (this.days <= 6) {
              this.alertExpire = true;
              this.variant = "warning";
            } else if (this.days <= 10) {
              this.alertExpire = true;
              this.variant = "info";
            }

            if (this.days === 1) {
              this.textAlert = this.$t("terminoTesteUmDia");
            } else {
              this.textAlert = `${this.$t("faltam")} ${this.days} ${this.$t(
                "xDiasTerminoTeste"
              )}`;
            }
          } else if (this.days <= 0) {
            if (userStatus === "trial" || userStatus == "trial_expired") {
              this.$router.replace({ name: "register-3" });
            } else if (
              userStatus === "waiting_payment" ||
              userStatus === "payment_not_made"
            ) {
              this.$router.replace({ name: "waiting-payment" });
            } else if (userStatus === "canceled") {
              this.$router.replace({ name: "login" });
            }
          }
        }
      }, 1500);
    },
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push({ name: "login" });
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
